function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  min-height: 100vh;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--theme-background, #f9fafb);\n  padding: 1rem;\n  \n  .dark & {\n    background-color: var(--theme-background-dark, #1f2937);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  max-width: 28rem;\n  padding: 3rem 1.5rem;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin: 0 auto;\n  height: 3rem;\n  width: 3rem;\n  color: var(--theme-danger, #ef4444);\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--theme-text, #111827);\n  \n  .dark & {\n    color: var(--theme-text-dark, #f9fafb);\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--theme-text-secondary, #6b7280);\n  \n  .dark & {\n    color: var(--theme-text-secondary-dark, #9ca3af);\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1rem;\n  text-align: left;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--theme-text, #374151);\n  \n  .dark & {\n    color: var(--theme-text-dark, #d1d5db);\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  border-radius: 0.375rem;\n  background-color: var(--theme-danger-light, #fef2f2);\n  padding: 0.75rem;\n  \n  .dark & {\n    background-color: var(--theme-danger-dark, rgba(185, 28, 28, 0.2));\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  font-family: ui-monospace, SFMono-Regular, 'SF Mono', monospace;\n  color: var(--theme-danger-dark, #991b1b);\n  \n  .dark & {\n    color: var(--theme-danger-light, #fca5a5);\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  max-height: 10rem;\n  overflow: auto;\n  font-size: 0.75rem;\n  font-family: ui-monospace, SFMono-Regular, 'SF Mono', monospace;\n  color: var(--theme-danger-dark, #7f1d1d);\n  \n  .dark & {\n    color: var(--theme-danger-light, #f87171);\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  \n  @media (min-width: 640px) {\n    flex-direction: row;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  cursor: pointer;\n  \n  @media (min-width: 640px) {\n    width: auto;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Component } from 'react';
import styled from '@emotion/styled';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
var ErrorContainer = styled.div(_templateObject());
var ErrorCard = styled.div(_templateObject1());
var ErrorIconWrapper = styled.div(_templateObject2());
var ErrorIcon = function() {
    return /*#__PURE__*/ React.createElement(ErrorIconWrapper, null, /*#__PURE__*/ React.createElement(ExclamationTriangleIcon, {
        style: {
            width: '100%',
            height: '100%'
        }
    }));
};
var ErrorTitle = styled.h1(_templateObject3());
var ErrorDescription = styled.p(_templateObject4());
var ErrorDetails = styled.details(_templateObject5());
var ErrorSummary = styled.summary(_templateObject6());
var ErrorContent = styled.div(_templateObject7());
var ErrorText = styled.p(_templateObject8());
var ErrorStack = styled.pre(_templateObject9());
var ButtonContainer = styled.div(_templateObject10());
var Button = styled.button(_templateObject11(), function(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'primary' : _param_variant;
    return variant === 'primary' ? "\n    background-color: var(--theme-primary, #3b82f6);\n    color: white;\n    border: none;\n    \n    &:hover {\n      background-color: var(--theme-primary-hover, #2563eb);\n    }\n  " : "\n    background-color: transparent;\n    color: var(--theme-text, #374151);\n    border: 1px solid var(--theme-border, #d1d5db);\n    \n    &:hover {\n      background-color: var(--theme-hover, #f3f4f6);\n    }\n    \n    .dark & {\n      color: var(--theme-text-dark, #d1d5db);\n      border-color: var(--theme-border-dark, #4b5563);\n      \n      &:hover {\n        background-color: var(--theme-hover-dark, #374151);\n      }\n    }\n  ";
});
/**
 * 에러 바운더리 컴포넌트
 * React 컴포넌트 트리에서 발생하는 에러를 포착하고 처리
 */ export var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    function ErrorBoundary(props) {
        _class_call_check(this, ErrorBoundary);
        var _this;
        _this = _call_super(this, ErrorBoundary, [
            props
        ]), _define_property(_this, "handleRetry", function() {
            _this.setState({
                hasError: false,
                error: undefined,
                errorInfo: undefined
            });
        }), _define_property(_this, "handleReload", function() {
            window.location.reload();
        });
        _this.state = {
            hasError: false
        };
        return _this;
    }
    _create_class(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                // 에러 정보를 상태에 저장
                this.setState({
                    error: error,
                    errorInfo: errorInfo
                });
                // 에러 리포팅 서비스에 에러를 로그
                console.error('ErrorBoundary가 에러를 포착했습니다:', error, errorInfo);
                // 부모 컴포넌트에 에러 알림
                if (this.props.onError) {
                    this.props.onError(error, errorInfo);
                }
                // 개발 모드에서는 에러 정보를 더 자세히 출력
                if (process.env.NODE_ENV === 'development') {
                    console.group('🚨 ErrorBoundary Error Details');
                    console.error('Error:', error);
                    console.error('Component Stack:', errorInfo.componentStack);
                    console.groupEnd();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    // 사용자 정의 폴백 UI가 있으면 사용
                    if (this.props.fallback) {
                        return this.props.fallback;
                    }
                    // 기본 에러 UI 렌더링
                    return /*#__PURE__*/ React.createElement(ErrorContainer, null, /*#__PURE__*/ React.createElement(ErrorCard, null, /*#__PURE__*/ React.createElement(ErrorIcon, null), /*#__PURE__*/ React.createElement(ErrorTitle, null, "앱에서 오류가 발생했습니다"), /*#__PURE__*/ React.createElement(ErrorDescription, null, "예상치 못한 문제가 발생했습니다. 문제가 지속되면 새로고침을 시도해 주세요."), process.env.NODE_ENV === 'development' && this.state.error && /*#__PURE__*/ React.createElement(ErrorDetails, null, /*#__PURE__*/ React.createElement(ErrorSummary, null, "에러 세부사항 보기"), /*#__PURE__*/ React.createElement(ErrorContent, null, /*#__PURE__*/ React.createElement(ErrorText, null, this.state.error.toString()), this.state.errorInfo && /*#__PURE__*/ React.createElement(ErrorStack, null, this.state.errorInfo.componentStack))), /*#__PURE__*/ React.createElement(ButtonContainer, null, /*#__PURE__*/ React.createElement(Button, {
                        variant: "primary",
                        onClick: this.handleRetry
                    }, "다시 시도"), /*#__PURE__*/ React.createElement(Button, {
                        variant: "secondary",
                        onClick: this.handleReload
                    }, "페이지 새로고침"))));
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                // 다음 렌더링에서 폴백 UI가 보이도록 상태를 업데이트
                return {
                    hasError: true,
                    error: error
                };
            }
        }
    ]);
    return ErrorBoundary;
}(Component);
/**
 * 함수형 컴포넌트를 위한 간단한 에러 바운더리 HOC
 */ export function withErrorBoundary(Component, fallback, onError) {
    var WrappedComponent = function(props) {
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            fallback: fallback,
            onError: onError
        }, /*#__PURE__*/ React.createElement(Component, props));
    };
    WrappedComponent.displayName = "withErrorBoundary(".concat(Component.displayName || Component.name, ")");
    return WrappedComponent;
}
export default ErrorBoundary;
